import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrganizationModel } from '../models/organization.model';
import { environment } from "../../environments/environment";
import { PaginatedResponse } from "../models/paginated-response";
import { Pagination } from "../shared/interfaces/pagination";
import { TractorTypeModel } from "../models/tractor-type.model";

@Injectable()
export class OrganizationDataSource {

  constructor(
    private http: HttpClient
  ) {
  }

  getOrganizations(pagination: Pagination = {}, nameFilter?: string): Observable<PaginatedResponse<OrganizationModel>> {
    const params = {};
    if (pagination?.pageNumber) {
      params['pageNumber'] = pagination.pageNumber;
    }

    if (pagination?.removeLimit) {
      params['removeLimit'] = pagination.removeLimit;
    }

    if (pagination?.pageSize) {
      params['pageSize'] = pagination.pageSize;
    }

    if (nameFilter && nameFilter !== '') {
      params['name'] = nameFilter;
    }

    return this.http.get<PaginatedResponse<OrganizationModel>>(
      environment.backendApi + 'api/Organization/GetOrganizations',
      {params}
    );
  }


  getOrganization(organizationId: number): Observable<OrganizationModel> {
    return this.http.get<OrganizationModel>(environment.backendApi + 'api/Organization/GetOrganization/' + organizationId);
  }

  deleteOrganization(organizationId: number): Observable<void> {
    return this.http.delete<void>(environment.backendApi + 'api/Organization/Delete/' + organizationId);
  }

  createOrganization(organizationName: string): Observable<OrganizationModel> {
    return this.http.post<OrganizationModel>(`${environment.backendApi}api/Organization`, {organizationName});
  }
}

